export default __webpack_public_path__ + "static/media/s_facebook_l.0858cec6.svg";